import { render, staticRenderFns } from "./DownloadsPlanoSaude.vue?vue&type=template&id=32022762"
import script from "./DownloadsPlanoSaude.vue?vue&type=script&lang=ts"
export * from "./DownloadsPlanoSaude.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports